
import { Head } from '@inertiajs/react';
import ChatInterface from '../components/ChatInterface';
import DashboardLayout from '../components/DashboardLayout';
import ErrorBoundary from '../components/ErrorBoundary';

interface Message {
  id: string;
  role: string;
  content: string;
  created_at: string;
}

interface Chat {
  id?: string;
  name: string | null;
  display_name: string;
  messages: Message[];
}

interface Props {
  chat: Chat;
}

export default function Chat({ chat }: Props) {
  const initialMessages = chat.messages.map((msg) => ({
    id: msg.id,
    role: msg.role,
    parts: [{ type: 'text' as const, text: msg.content }],
  }));

  return (
    <DashboardLayout>
      <Head title="Chat" />
      <div className="h-full">
        <ErrorBoundary>
          <ChatInterface
            chatId={chat.id}
            initialMessages={initialMessages}
            chatName={chat.display_name}
          />
        </ErrorBoundary>
      </div>
    </DashboardLayout>
  );
}